/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewdownload2Inputs */

const en_letterpreviewdownload2 = /** @type {(inputs: Letterpreviewdownload2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Portuguese letter (PDF)`)
};

const pt_letterpreviewdownload2 = /** @type {(inputs: Letterpreviewdownload2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregar carta (PDF)`)
};

/**
* | output |
* | --- |
* | "Download Portuguese letter (PDF)" |
*
* @param {Letterpreviewdownload2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewdownload2 = /** @type {((inputs?: Letterpreviewdownload2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewdownload2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewdownload2(inputs)
	return pt_letterpreviewdownload2(inputs)
});
export { letterpreviewdownload2 as "letterPreviewDownload" }